<template>
    <form :action="currentSearch">
        <div class="box box--white box--advanced-search">
            <p class="title">
                Opciones de búsqueda adicionales
            </p>

            <div class="form-grid">
                <div class="form-group sm:col-10">
                    <label class="form-label" for="conditions_select">
                        Condición
                    </label>
                    <v-select
                        v-model="filters.conditions"
                        :reduce="condition => condition.value"
                        :options="getConditions()"
                        placeholder="- Selecciona la condición -"
                        label="name"
                        multiple
                        class="form-input form-input--big"
                        name="conditions"
                        id="conditions_select"
                    >
                        <span slot="no-options">Sin resultados</span>
                    </v-select>
                </div>

                <div class="form-group sm:col-3">
                    <label class="form-label" for="years_from_select">
                        Rango de años
                    </label>
                    <v-select
                        v-model="filters.years.from"
                        :reduce="years => years.value"
                        :options="getYears()"
                        placeholder="- Del año -"
                        label="name"
                        class="form-input form-input--big"
                        name="years_from"
                        id="years_from_select"
                    >
                        <span slot="no-options">Sin resultados</span>
                    </v-select>
                </div>

                <div class="form-group sm:col-3 flex align-items-end">
                    <v-select
                        v-model="filters.years.to"
                        :reduce="years => years.value"
                        :options="getYears()"
                        placeholder=" - Al año - "
                        label="name"
                        class="form-input form-input--big"
                        name="years_to"
                        id="years_to_select"
                    >
                        <span slot="no-options">Sin resultados</span>
                    </v-select>
                </div>
            </div>

            <div class="form-grid">
                <div class="form-group sm:col-10">
                    <label class="form-label" for="kilometers_select">
                        Kilometraje
                    </label>
                    <v-select
                        v-model="filters.kilometers"
                        :reduce="kilometers => kilometers.value"
                        :options="getKilometers()"
                        placeholder="- Selecciona el kilometraje -"
                        label="name"
                        class="form-input form-input--big"
                        name="kilometers"
                        id="kilometers_select"
                    >
                        <span slot="no-options">Sin resultados</span>
                    </v-select>
                </div>

                <div class="form-group sm:col-3">
                    <label class="form-label" for="prices_from_select">
                        Rango de precio
                    </label>
                    <v-select
                        v-model="filters.prices.from"
                        :reduce="prices => prices.value"
                        :options="getPrices()"
                        placeholder=" - Precio minimo - "
                        label="name"
                        taggable
                        push-tags
                        class="form-input form-input--big"
                        name="prices"
                        id="prices_from_select"
                    >
                        <span slot="no-options">Sin resultados</span>
                    </v-select>
                </div>

                <div class="form-group sm:col-3 flex align-items-end">
                    <v-select
                        v-model="filters.prices.to"
                        :reduce="prices => prices.value"
                        :options="getPrices()"
                        placeholder=" - Precio máximo - "
                        label="name"
                        taggable
                        push-tags
                        class="form-input form-input--big"
                        name="prices"
                        id="prices_to_select"
                    >
                        <span slot="no-options">Sin resultados</span>
                    </v-select>
                </div>
            </div>

            <div class="form-grid">
                <div class="form-group sm:col-5">
                    <label class="form-label" for="colors_select">
                        Color exterior
                    </label>
                    <v-select
                        v-model="filters.colors"
                        :reduce="colors => colors.value"
                        :options="getColors()"
                        placeholder=" - Selecciona uno o mas colores - "
                        label="name"
                        multiple
                        class="form-input form-input--big"
                        name="colors"
                        id="colors_select"
                    >
                        <span slot="no-options">Sin resultados</span>
                    </v-select>
                </div>

                <div class="form-group sm:col-6">
                    <label class="form-label" for="transmissions_select">
                        Transmisión
                    </label>
                    <v-select
                        v-model="filters.transmissions"
                        :reduce="transmissions => transmissions.value"
                        :options="getTransmissions()"
                        placeholder=" - Selecciona una transmisión - "
                        label="name"
                        multiple
                        class="form-input form-input--big"
                        name="transmissions"
                        id="transmissions_select"
                    >
                        <span slot="no-options">Sin resultados</span>
                    </v-select>
                </div>
            </div>
        </div>

        <div class="box box--white box--advanced-search">
            <p class="title">
                Marca y modelo
            </p>
            <div class="form-grid">
                <div class="form-group sm:col-8">
                    <label class="form-label" for="">
                        Marca
                    </label>
                    <v-select
                        v-model="filters.brands"
                        :reduce="brands => brands.value"
                        :options="getBrands()"
                        placeholder=" - Selecciona la marca - "
                        label="name"
                        class="form-input form-input--big"
                        name="brands"
                        id="brands_select"
                    >
                        <span slot="no-options">Sin resultados</span>
                    </v-select>
                </div>
                <div class="form-group sm:col-8">
                    <label class="form-label" for="">
                        Modelo
                    </label>
                    <v-select
                        v-model="filters.models"
                        :reduce="models => models.value"
                        :options="getModels()"
                        placeholder=" - Selecciona la marca - "
                        label="name"
                        multiple
                        class="form-input form-input--big"
                        name="models"
                        id="models_select"
                    >
                        <span slot="no-options">Sin resultados</span>
                    </v-select>
                </div>
            </div>
        </div>

        <!-- <div class="box box--white box--advanced-search">
            <p class="title">
                Tipo de auto
            </p>
            <div class="grid grid__type">
                <div
                    v-for="(car_type, key) in getTypes()"
                    :key="key"
                    class="item box box--white"
                >
                    <input
                        v-model="filters.types"
                        :value="car_type.id"
                        class="checkbox-type-car"
                        :id="'type-' + car_type.id"
                        type="checkbox"
                    />
                    <label :for="'type-' + car_type.id">
                        <img
                            class="shape-car mb-2"
                            :src="'/files/car_types/' + car_type.image"
                        />
                        <p class="m-0">
                            {{ car_type.title }}
                        </p>
                        <span class="mask__check">
                            <img
                                width="8px"
                                src="/assets/images/helpers/icon-check-white.svg"
                                alt=""
                            />
                        </span>
                    </label>
                </div>
            </div>
        </div> -->

        <input
            @click="getProducts($event)"
            class="btn btn--green-ad btn--advanced-search weight-700 tx-16 flex ml-a"
            type="submit"
            value="Buscar"
        />
    </form>
</template>

<script>
import { mapState } from "vuex";
import { TheMask } from "vue-the-mask";
import vSelect from "vue-select";

import "vue-select/dist/vue-select.css";

Vue.component("v-select", vSelect);
export default {
    components: {
        TheMask
    },

    data: () => ({
        currentSearch: "/catalogo",
        filters: {
            kilometers: {
                from: 0,
                to: 0
            },
            prices: {
                from: 0,
                to: 0
            },
            years: {
                from: 0,
                to: 0
            },
            plus: {
                one_owner: false,
                invoice: false,
                user_verify: false
            },
            brands: [],
            colors: [],
            models: [],
            transmissions: [],
            conditions: [],
            types: [],
            user_type: [],
            score: []
        }
    }),

    created() {
        this.$store.dispatch("catalog/getBrands");
        this.$store.dispatch("catalog/getModels");
        this.$store.dispatch("catalog/getProductColors");
        this.$store.dispatch("catalog/getProductTransmissions");
        this.$store.dispatch("catalog/getProductConditions");
        this.$store.dispatch("catalog/getProductTypes");
        this.$store.dispatch("catalog/getYears");
    },

    watch: {
        filters: {
            handler(value) {
                this.setQueryToLocation();
            },
            deep: true
        }
    },

    methods: {
        getConditions() {
            return _.map(this.$store.state.catalog.conditions, function(
                item,
                key
            ) {
                return {
                    name: item.title,
                    value: item.id
                };
            });
        },

        getTransmissions() {
            return _.map(this.$store.state.catalog.transmissions, function(
                item,
                key
            ) {
                return {
                    name: item.title,
                    value: item.id
                };
            });
        },

        getBrands() {
            return _.map(this.$store.state.catalog.brands, function(item, key) {
                return {
                    name: item.title,
                    value: item.id
                };
            });
        },

        getModels() {
            let vm = this;
            let data = _.filter(this.$store.state.catalog.models, function(
                item,
                key
            ) {
                return item.brand_id === vm.filters.brands;
            });

            return _.map(data, function(item, key) {
                return {
                    name: item.title,
                    value: item.id
                };
            });
        },

        getYears() {
            return _.map(this.$store.state.catalog.years, function(item, key) {
                return {
                    name: item.year,
                    value: item.year
                };
            });
        },

        getKilometers() {
            let data = [
                {
                    title: "10,000 o menor",
                    id: { from: 0, to: 10000 }
                },
                {
                    title: "20,000 o menor",
                    id: { from: 0, to: 20000 }
                },
                {
                    title: "30,000 o menor",
                    id: { from: 0, to: 30000 }
                },
                {
                    title: "40,000 o menor",
                    id: { from: 0, to: 40000 }
                },
                {
                    title: "40,000 o mayor",
                    id: { from: 40000, to: 0 }
                }
            ];
            return _.map(data, function(item, key) {
                return {
                    name: item.title,
                    value: item.id
                };
            });
        },

        getPrices() {
            let data = [
                {
                    title: "$100,000",
                    id: 100000
                },
                {
                    title: "$200,000",
                    id: 200000
                },
                {
                    title: "$300,000",
                    id: 300000
                },
                {
                    title: "$400,000",
                    id: 400000
                },
                {
                    title: "$500,000",
                    id: 500000
                },
                {
                    title: "$600,000",
                    id: 600000
                },
                {
                    title: "$700,000",
                    id: 700000
                },
                {
                    title: "$800,000",
                    id: 800000
                },
                {
                    title: "$900,000",
                    id: 900000
                },
                {
                    title: "$1,000,000",
                    id: 1000000
                },
                {
                    title: "$1,000,000 o más",
                    id: 1000001
                }
            ];
            return _.map(data, function(item, key) {
                return {
                    name: item.title,
                    value: item.id
                };
            });
        },

        getUserType() {
            let data = [
                {
                    title: "Agencia",
                    id: "agencia"
                },
                {
                    title: "Particular",
                    id: "particular"
                }
            ];
            return _.map(data, function(item, key) {
                return {
                    name: item.title,
                    value: item.id
                };
            });
        },

        getColors() {
            return _.map(this.$store.state.catalog.colors, function(item, key) {
                return {
                    name: item.title,
                    value: item.id
                };
            });
        },

        getTypes() {
            return _.map(this.$store.state.catalog.productType, function(
                item,
                key
            ) {
                return {
                    title: item.title,
                    id: item.id,
                    image: item.image
                };
            });
        },

        filterBrand(id, column) {
            let vm = this;
            if (!vm.brands) {
                vm.$refs.dropdownBrands.click();
            } else {
                if (vm.brands) {
                    return _.head(
                        _.filter(vm.brands, function(item, key) {
                            return id == item.id;
                        })
                    )[column];
                }
                return "";
            }
        },

        setQueryToLocation() {
            let vm = this;
            let CurrentUrl = window.location.origin + "/catalogo";
            let urlSearch = _.join(
                _.map(vm.filters, function(value, query) {
                    var toString = value;
                    if (Array.isArray(value)) {
                        toString = value.join(",");
                    } else if (typeof value === "object") {
                        toString = _.map(value, function(v, k) {
                            return k + ":" + v;
                        }).join(",");
                    }
                    return query + "=" + toString;
                }),
                "&"
            );

            vm.currentSearch = CurrentUrl + "?" + urlSearch;
        },

        getProducts(event) {
            event.preventDefault();
            window.location.href = this.currentSearch;
        }
    }
};
</script>
